import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircle, Mail, Phone, Calendar, CreditCard } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';

const EnrollmentSuccessPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const enrollmentId = location.state?.enrollmentId;

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--bg-primary)' }}>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <Card className="premium-card p-8 md:p-12 text-center">
          {/* Success Icon */}
          <div className="w-20 h-20 mx-auto mb-6 rounded-full flex items-center justify-center"
            style={{ backgroundColor: 'rgba(16, 185, 129, 0.1)' }}>
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>

          {/* Heading */}
          <h1 className="heading-xl mb-4">Enrollment Submitted Successfully!</h1>
          <p className="text-lg mb-8" style={{ color: 'var(--text-grey)' }}>
            Thank you for choosing Winhouse Tutors. We've received your enrollment request and our team will review it shortly.
          </p>

          {/* What's Next */}
          <div className="mb-8 text-left">
            <h2 className="heading-md mb-4">What Happens Next?</h2>
            <div className="space-y-4">
              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: 'var(--accent-teal)', color: 'white' }}>
                  <span className="font-bold">1</span>
                </div>
                <div>
                  <h3 className="font-semibold mb-1">We'll Review Your Request</h3>
                  <p className="text-sm" style={{ color: 'var(--text-grey)' }}>
                    Our team will carefully review your academic needs and preferences within 24 hours.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: 'var(--accent-teal)', color: 'white' }}>
                  <span className="font-bold">2</span>
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Tutor Matching & Confirmation</h3>
                  <p className="text-sm" style={{ color: 'var(--text-grey)' }}>
                    We'll confirm your tutor assignment and reach out to schedule your first lesson.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: 'var(--accent-teal)', color: 'white' }}>
                  <span className="font-bold">3</span>
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Start Your Learning Journey</h3>
                  <p className="text-sm" style={{ color: 'var(--text-grey)' }}>
                    Begin your tailored tutoring sessions and work towards your academic goals.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="mb-8 p-6 rounded-lg" style={{ backgroundColor: 'var(--bg-light)' }}>
            <h3 className="font-semibold mb-4">Need to reach us?</h3>
            <div className="grid md:grid-cols-2 gap-4 text-sm">
              <div className="flex items-center gap-2 justify-center">
                <Mail className="w-4 h-4" style={{ color: 'var(--accent-teal)' }} />
                <a href="mailto:info@winhousetutors.com" className="hover:underline"
                  style={{ color: 'var(--accent-teal)' }}>
                  info@winhousetutors.com
                </a>
              </div>
              <div className="flex items-center gap-2 justify-center">
                <Phone className="w-4 h-4" style={{ color: 'var(--accent-teal)' }} />
                <a href="tel:+61481865742" className="hover:underline"
                  style={{ color: 'var(--accent-teal)' }}>
                  +61 481 865 742
                </a>
              </div>
            </div>
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate('/pay')}
              className="premium-button flex items-center gap-2"
            >
              <CreditCard className="w-4 h-4" />
              Continue to Payment
            </Button>
            <Button
              onClick={() => navigate('/')}
              className="premium-button-secondary"
            >
              Return to Homepage
            </Button>
          </div>
          
          <p className="mt-4 text-sm" style={{ color: 'var(--text-grey)' }}>
            Ready to get started? Choose a lesson package to begin your tutoring journey.
          </p>
        </Card>
      </div>
    </div>
  );
};

export default EnrollmentSuccessPage;
